module.exports = __webpack_public_path__ + "img/align-left.97797528.svg";